import React from 'react';
import Logo from '../Logo/Logo';

export default class LoginLogo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hidden: false,
            small: false,
            large: false,
            canResize: false,
            params: this.props.params
        };
    }

    componentDidMount() {
        var self = this;
        this.state.canResize = true;
        window.onresize = () => {
            if ((window.innerWidth < self.state.params.hideAtWidth) && self.state.hidden == false) {
                self.setState({
                    hidden: true,
                    small: false,
                    large: false
                });
            }
            else if ((window.innerHeight < self.state.params.hideAtHeight) && self.state.hidden == false) {
                self.setState({
                    hidden: true,
                    small: false,
                    large: false
                });
            } else if ((window.innerHeight < self.state.params.smallAtHeight) && (window.innerHeight > self.state.params.hideAtHeight) && (window.innerWidth > self.state.params.hideAtWidth) && self.state.small == false) {
                self.setState({
                    hidden: false,
                    small: true,
                    large: false
                });
            } else if ((window.innerWidth < 450) && (window.innerHeight > self.state.params.hideAtHeight) && (window.innerWidth > self.state.params.hideAtWidth) && self.state.small == false) {
                self.setState({
                    hidden: false,
                    small: true,
                    large: false
                });
            } else if ((window.innerHeight > self.state.params.smallAtHeight) && (window.innerWidth > 450) && self.state.large == false) {
                self.setState({
                    hidden: false,
                    small: false,
                    large: true
                });
            }
        };
        this.updateStyle(this.state.params);
    }

    componentWillUnmount() {
        this.state.canResize = false; // Makes sure that the media queries are detached
    }                                 // inorder to handle sibling LoginLogo components

    componentWillReceiveProps(props) {
        var self = this;
        this.setState({
            hidden: false,
            small: false,
            large: false,
            params: props.params
        });
        window.onresize = () => {
            if ((window.innerWidth < self.state.params.hideAtWidth) && self.state.hidden == false) {
                self.setState({
                    hidden: true,
                    small: false,
                    large: false
                });
            }
            else if ((window.innerHeight < self.state.params.hideAtHeight) && self.state.hidden == false) {
                self.setState({
                    hidden: true,
                    small: false,
                    large: false
                });
            } else if ((window.innerHeight < self.state.params.smallAtHeight) && (window.innerHeight > self.state.params.hideAtHeight) && (window.innerWidth > self.state.params.hideAtWidth) && self.state.small == false) {
                self.setState({
                    hidden: false,
                    small: true,
                    large: false
                });
            } else if ((window.innerWidth < 450) && (window.innerHeight > self.state.params.hideAtHeight) && (window.innerWidth > self.state.params.hideAtWidth) && self.state.small == false) {
                self.setState({
                    hidden: false,
                    small: true,
                    large: false
                });
            } else if ((window.innerHeight > self.state.params.smallAtHeight) && (window.innerWidth > 450) && self.state.large == false) {
                self.setState({
                    hidden: false,
                    small: false,
                    large: true
                });
            }
        };
        this.updateStyle(props.params);
    }

    updateStyle(params) {
        var self = this;
        if ((window.innerWidth < params.hideAtWidth)) {
            self.setState({
                hidden: true,
                small: false,
                large: false
            });
        }
        else if ((window.innerHeight < params.hideAtHeight)) {
            self.setState({
                hidden: true,
                small: false,
                large: false
            });
        } else if ((window.innerHeight < params.smallAtHeight) && (window.innerHeight > params.hideAtHeight) && (window.innerWidth > params.hideAtWidth)) {
            self.setState({
                hidden: false,
                small: true,
                large: false
            });
        } else if ((window.innerWidth < 450) && (window.innerHeight > params.hideAtHeight) && (window.innerWidth > params.hideAtWidth)) {
            self.setState({
                hidden: false,
                small: true,
                large: false
            });
        } else if ((window.innerHeight > params.smallAtHeight) && (window.innerWidth > 450)) {
            self.setState({
                hidden: false,
                small: false,
                large: true
            });
        }
    }

    render() {
        const styles = {
            login_logo: {
                small: {
                    transform: "unset"
                },
                large: {
                    transform: "scale(1.3)"
                }
            },
            login_logo_container: {
                small: {
                    display: "flex",
                    justifyContent: "flex-start",
                    marginLeft: "-15px"
                },
                large: {
                    display: "flex",
                    justifyContent: "center"
                }
            },
            login_logo_box: {
                small: {
                    marginTop: "calc(50vh - ( " + this.props.params.contentHeight + " / 2 ) - 60px - 35px)",
                    marginBottom: "15px"
                },
                large: {
                    marginTop: "50px"
                }
            }
        };
        return(
            <div>
                {( this.state.hidden == true) && (
                    <div style={{padding: "15px"}}/>
                )}
                {(this.state.small == true) && (
                    <div>
                        <div class="login-box" style={styles.login_logo_box.small}>
                            <div class="center" style={styles.login_logo_container.small} >
                                <Logo height={59} />
                            </div>
                        </div>
                    </div>
                )}
                {( this.state.large == true) && (
                    <div>
                        <div class="login-box" style={styles.login_logo_box.large}>
                            <div class="center" style={styles.login_logo_container.large} >
                                <Logo height={77} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
};



// WEBPACK FOOTER //
// app/components/Login/LoginLogo.jsx